/**
 * turn_state acceptance guard — pure, unit-tested.
 *
 * The backend's TURN_STATE frames carry a monotonic per-session `turn_id`.
 * One genuine race exists server-side: the debounced idle task runs on its
 * own asyncio task, and once past its sleep the cancel issued by a new user
 * turn is a no-op — so an `idle` for turn N can hit the wire after
 * `thinking` for turn N+1. Accepting it would clear the fresh turn's
 * indicator mid-work.
 *
 * Rule: accept a frame iff its turn_id is >= the newest id seen this
 * connection. `>=` (not `>`) because a turn legitimately emits several
 * frames under one id (thinking → using_tool → responding → idle).
 * The caller resets `lastId` to -1 on socket close — turn ids restart
 * per backend session, and frame 0 (pre-first-turn emissions, e.g. a
 * greeting's responding/idle) must be acceptable on a fresh connection.
 */
export function shouldAcceptTurnState(
  lastId: number,
  incomingId: number
): boolean {
  return incomingId >= lastId;
}
